export enum LoadPlanProperties {
  borderLinePropertiesWithColor = '0.2em solid #feb601',
  borderLinePropertiesWithoutColor = '0.2em solid '
}
